import { fetchUser } from '@/routes/admin.tsx';
import { createFileRoute, redirect } from '@tanstack/react-router';
import ForgotPassword from '../pages/auth/ForgotPassword';

export const Route = createFileRoute('/forgot-password')({
  beforeLoad: async () => {
    const user = await fetchUser();

    if (user) {
      throw redirect({ to: '/admin' });
    }
  },
  component: ForgotPassword,
});
